import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Blog({ articles }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextArticles = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 3 >= articles.length ? 0 : prevIndex + 3));
  };

  const prevArticles = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 3 < 0 ? Math.max(articles.length - 3, 0) : prevIndex - 3));
  };

  return (
    <section id="blog" className="section">
      <h2>Blog</h2>
      <div className="blog-container">
        {articles.slice(currentIndex, currentIndex + 3).map((article, index) => (
          <div key={index} className="blog-card">
            <img src={article.image} alt={article.title} className="blog-image" />
            <h3>{article.title}</h3>
            <p>{article.excerpt}</p>
            <Link to={`/Article/${article.id}`} className="read-more">Read More</Link>
          </div>
        ))}
      </div>
      <div className="blog-nav">
        <button onClick={prevArticles} className="nav-button">Previous</button>
        <button onClick={nextArticles} className="nav-button">Next</button>
      </div>
    </section>
  );
}

export default Blog;
